module.exports = __webpack_public_path__ + "img/logobkpsdm.c5326914.png";